module.exports = __webpack_public_path__ + "./docs/img/icon-namespace.e0a7d98ecaa93289185e02b83e1951ce.svg";